import React from 'react';
import classnames from 'classnames';
import i18n from '../libs/i18n';

import Section from './Section.jsx';

export default class SectionFooter extends React.Component {
  render() {
    const homepageUrl = 'http://elconmegarad.com';

    const styles = {
      gotoButton: classnames('button', 'button--huge'),
      footer: classnames('text-center'),
    };

    return (
      <Section id={'footer'} color={'white'}>
        <div className={styles.footer}>
          <a className={styles.gotoButton} href={homepageUrl}>{i18n.translate('footer.link')}</a>
        </div>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionFooter.jsx
 **/